(function(){
'use strict';

var $ = function(s){ return document.querySelector(s); };
var $$ = function(s){ return document.querySelectorAll(s); };

/* ── Page Loader ── */
window.addEventListener('load', function(){
  setTimeout(function(){
    var loader = $('#pageLoader');
    if(loader) loader.classList.add('hidden');
    animateHero();
  }, 800);
});

function animateHero(){
  var ids = ['heroWord1','heroWord2','heroEst','heroDivider','heroQuote','heroSeal','scrollHint'];
  var delays = [100, 350, 600, 800, 1000, 1300, 1800];
  ids.forEach(function(id, i){
    var el = document.getElementById(id);
    if(el) setTimeout(function(){ el.classList.add('visible'); }, delays[i]);
  });
}

/* ── Theme Toggle ── */
var themeToggle = $('#themeToggle');
var root = document.documentElement;
var savedTheme = localStorage.getItem('ep-parchment-theme');
if(savedTheme) root.setAttribute('data-theme', savedTheme);
if(themeToggle){
  themeToggle.addEventListener('click', function(){
    var isLight = root.getAttribute('data-theme') === 'light';
    root.setAttribute('data-theme', isLight ? 'dark' : 'light');
    localStorage.setItem('ep-parchment-theme', isLight ? 'dark' : 'light');
  });
}

/* ── Nav Scroll Effect ── */
var mainNav = $('#mainNav');
if(mainNav){
  window.addEventListener('scroll', function(){
    if(window.scrollY > 60) mainNav.classList.add('scrolled');
    else mainNav.classList.remove('scrolled');
  }, {passive: true});
}

/* ── Mobile Menu ── */
var navToggle = $('#navToggle');
var mobileMenu = $('#mobileMenu');
function closeMobileMenu(){
  if(navToggle) navToggle.classList.remove('open');
  if(mobileMenu) mobileMenu.classList.remove('open');
  document.body.classList.remove('no-scroll');
}
if(navToggle){
  navToggle.addEventListener('click', function(){
    navToggle.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    document.body.classList.toggle('no-scroll', mobileMenu.classList.contains('open'));
  });
}

/* ── Cart Sidebar ── */
var cartOverlay = $('#cartOverlay');
var cartSidebar = $('#cartSidebar');
var cartItemsEl = $('#cartItems');
var cartFooter = $('#cartFooter');
var cartSubtotal = $('#cartSubtotal');
var cartBadge = $('#cartBadge');

function openCart(){
  if(cartOverlay) cartOverlay.classList.add('open');
  if(cartSidebar) cartSidebar.classList.add('open');
  document.body.classList.add('no-scroll');
}
function closeCart(){
  if(cartOverlay) cartOverlay.classList.remove('open');
  if(cartSidebar) cartSidebar.classList.remove('open');
  document.body.classList.remove('no-scroll');
}

var cartBtn = $('#cartBtn');
if(cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
var cartClose = $('#cartClose');
if(cartClose) cartClose.addEventListener('click', closeCart);
if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

/* Fetch fresh cart from Shopify and re-render sidebar */
function refreshCart(){
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      if(cartBadge){
        cartBadge.textContent = cart.item_count;
        cartBadge.classList.toggle('visible', cart.item_count > 0);
      }
      if(cartFooter) cartFooter.style.display = cart.item_count > 0 ? '' : 'none';
      if(cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      renderCartItems(cart);
    });
}

function formatMoney(cents){
  return '$' + (cents / 100).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2});
}

function renderCartItems(cart){
  if(!cartItemsEl) return;
  if(cart.item_count === 0){
    cartItemsEl.innerHTML = '<div class="cart-empty"><svg class="cart-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span class="cart-empty-text">Your collection awaits</span><span class="cart-empty-sub">No items yet</span></div>';
    return;
  }
  cartItemsEl.innerHTML = cart.items.map(function(item, i){
    var line = i + 1;
    return '<div class="cart-item" data-line="' + line + '">' +
      '<div class="cart-item-img"><img src="' + getSizedImage(item.image, '120x') + '" alt="' + escapeHtml(item.title) + '"></div>' +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + escapeHtml(item.product_title) + '</div>' +
        (item.variant_title ? '<div class="cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
        '<div class="cart-item-price">' + formatMoney(item.price) + '</div>' +
        '<div class="cart-item-controls">' +
          '<button class="cart-qty-btn" data-action="minus" data-line="' + line + '">&minus;</button>' +
          '<span class="cart-item-qty">' + item.quantity + '</span>' +
          '<button class="cart-qty-btn" data-action="plus" data-line="' + line + '">+</button>' +
          '<button class="cart-item-remove" data-line="' + line + '">Remove</button>' +
        '</div>' +
      '</div></div>';
  }).join('');

  bindCartItemEvents();
}

function bindCartItemEvents(){
  if(!cartItemsEl) return;
  cartItemsEl.querySelectorAll('.cart-qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = parseInt(this.dataset.line);
      var action = this.dataset.action;
      var qtyEl = this.parentElement.querySelector('.cart-item-qty');
      var qty = parseInt(qtyEl.textContent);
      var newQty = action === 'minus' ? qty - 1 : qty + 1;
      if(newQty < 0) newQty = 0;
      changeCartLine(line, newQty);
    });
  });
  cartItemsEl.querySelectorAll('.cart-item-remove').forEach(function(btn){
    btn.addEventListener('click', function(){
      changeCartLine(parseInt(this.dataset.line), 0);
    });
  });
}

function changeCartLine(line, quantity){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({line: line, quantity: quantity})
  })
  .then(function(r){ return r.json(); })
  .then(function(){ refreshCart(); });
}

/* ── Product Quick View Modal ── */
var productModal = $('#productModal');
var modalImg = $('#modalImg');
var modalName = $('#modalName');
var modalPrice = $('#modalPrice');
var modalDesc = $('#modalDesc');
var modalEdition = $('#modalEdition');
var modalSizes = $('#modalSizes');
var qtyValueEl = $('#qtyValue');
var addToCartBtn = $('#addToCartBtn');
var currentVariantId = null;
var modalQty = 1;

function openProductModal(handle){
  fetch('/products/' + handle + '.json')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var product = data.product;
      if(!product) return;

      if(modalImg){
        modalImg.src = product.image ? product.image.src : '';
        modalImg.alt = product.title;
      }
      if(modalName) modalName.textContent = product.title;
      if(modalPrice) modalPrice.textContent = formatMoney(product.variants[0].price * 100);
      if(modalDesc) modalDesc.innerHTML = product.body_html || '';
      if(modalEdition) modalEdition.textContent = 'Edition I';

      /* Render variant/size buttons */
      if(modalSizes && product.variants.length > 1){
        modalSizes.innerHTML = product.variants.map(function(v, i){
          return '<button class="size-btn' + (i === 0 ? ' selected' : '') + '" data-variant-id="' + v.id + '">' + v.title + '</button>';
        }).join('');
        modalSizes.parentElement.style.display = '';
        bindSizeButtons();
      } else if(modalSizes){
        modalSizes.parentElement.style.display = 'none';
      }

      currentVariantId = product.variants[0].id;
      modalQty = 1;
      if(qtyValueEl) qtyValueEl.textContent = '1';

      if(productModal){
        productModal.classList.add('open');
        document.body.classList.add('no-scroll');
      }
    });
}

function bindSizeButtons(){
  $$('#modalSizes .size-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      $$('#modalSizes .size-btn').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      currentVariantId = parseInt(this.dataset.variantId);
    });
  });
}

function closeProductModal(){
  if(productModal) productModal.classList.remove('open');
  document.body.classList.remove('no-scroll');
  currentVariantId = null;
}

var modalClose = $('#modalClose');
if(modalClose) modalClose.addEventListener('click', closeProductModal);
if(productModal) productModal.addEventListener('click', function(e){
  if(e.target === productModal) closeProductModal();
});

/* Qty controls in modal */
var qtyMinus = $('#qtyMinus');
var qtyPlus = $('#qtyPlus');
if(qtyMinus) qtyMinus.addEventListener('click', function(){
  if(modalQty > 1){ modalQty--; if(qtyValueEl) qtyValueEl.textContent = modalQty; }
});
if(qtyPlus) qtyPlus.addEventListener('click', function(){
  if(modalQty < 10){ modalQty++; if(qtyValueEl) qtyValueEl.textContent = modalQty; }
});

/* Add to cart from modal */
if(addToCartBtn) addToCartBtn.addEventListener('click', function(){
  if(!currentVariantId) return;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: currentVariantId, quantity: modalQty})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    refreshCart();
    addToCartBtn.classList.add('added');
    addToCartBtn.textContent = 'Added to Collection';
    setTimeout(function(){
      addToCartBtn.classList.remove('added');
      addToCartBtn.textContent = 'Add to Collection';
    }, 1200);
    if(cartBadge){
      cartBadge.style.transform = 'scale(1.3)';
      setTimeout(function(){ cartBadge.style.transform = 'scale(1)'; }, 300);
    }
  });
});

/* Quick View button clicks (event delegation) */
document.addEventListener('click', function(e){
  var qvBtn = e.target.closest('.quick-view-btn');
  if(qvBtn){
    e.preventDefault();
    e.stopPropagation();
    var handle = qvBtn.dataset.handle;
    if(handle) openProductModal(handle);
    return;
  }
  /* Product card click opens product page */
  var card = e.target.closest('.product-card');
  if(card && !e.target.closest('.quick-view-btn')){
    var cardHandle = card.dataset.productHandle;
    if(cardHandle) window.location.href = '/products/' + cardHandle;
  }
});

/* ── Product Page: Variant Selection ── */
$$('.size-btn-label').forEach(function(label){
  label.addEventListener('click', function(){
    $$('.size-btn-label').forEach(function(l){ l.classList.remove('selected'); });
    this.classList.add('selected');
  });
});

/* ── Product Page: Qty Controls ── */
var pageMinus = $('#pageMinus');
var pagePlus = $('#pagePlus');
var pageQtyValue = $('#pageQtyValue');
if(pageMinus) pageMinus.addEventListener('click', function(){
  var v = parseInt(pageQtyValue.value);
  if(v > 1) pageQtyValue.value = v - 1;
});
if(pagePlus) pagePlus.addEventListener('click', function(){
  var v = parseInt(pageQtyValue.value);
  if(v < 10) pageQtyValue.value = v + 1;
});

/* ── Product Page: Thumbnail Gallery ── */
document.addEventListener('click', function(e){
  var thumb = e.target.closest('.product-thumb');
  if(thumb){
    var mainImg = $('#productMainImg');
    if(mainImg) mainImg.src = thumb.dataset.img;
    $$('.product-thumb').forEach(function(t){ t.classList.remove('active'); });
    thumb.classList.add('active');
  }
});

/* ── Product Page: AJAX Add to Cart ── */
var productForm = $('#productForm');
if(productForm){
  productForm.addEventListener('submit', function(e){
    e.preventDefault();
    var formData = new FormData(productForm);
    var data = {
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity')) || 1
    };
    var submitBtn = productForm.querySelector('.add-to-cart-btn');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      refreshCart();
      openCart();
      if(submitBtn){
        submitBtn.classList.add('added');
        submitBtn.textContent = 'Added to Collection';
        setTimeout(function(){
          submitBtn.classList.remove('added');
          submitBtn.textContent = 'Add to Collection';
        }, 1500);
      }
    });
  });
}

/* ── Lightbox ── */
var lightboxOverlay = $('#lightboxOverlay');
var lightboxImg = $('#lightboxImg');
var lightboxCounter = $('#lightboxCounter');
var lightboxImages = [];
var lightboxIndex = 0;

function openLightbox(src, images, index){
  lightboxImages = images || [{src: src}];
  lightboxIndex = index || 0;
  updateLightbox();
  if(lightboxOverlay) lightboxOverlay.classList.add('active');
  document.body.classList.add('no-scroll');
}
function closeLightbox(){
  if(lightboxOverlay) lightboxOverlay.classList.remove('active');
  document.body.classList.remove('no-scroll');
}
function updateLightbox(){
  if(lightboxImg) lightboxImg.src = lightboxImages[lightboxIndex].src;
  if(lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
}

var lightboxClose = $('#lightboxClose');
if(lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
if(lightboxOverlay) lightboxOverlay.addEventListener('click', function(e){
  if(e.target === lightboxOverlay) closeLightbox();
});
var lightboxPrev = $('#lightboxPrev');
var lightboxNext = $('#lightboxNext');
if(lightboxPrev) lightboxPrev.addEventListener('click', function(e){
  e.stopPropagation();
  lightboxIndex = (lightboxIndex - 1 + lightboxImages.length) % lightboxImages.length;
  updateLightbox();
});
if(lightboxNext) lightboxNext.addEventListener('click', function(e){
  e.stopPropagation();
  lightboxIndex = (lightboxIndex + 1) % lightboxImages.length;
  updateLightbox();
});

/* Lookbook image clicks open lightbox grouped by section */
document.addEventListener('click', function(e){
  var item = e.target.closest('.lookbook-item');
  if(!item) return;
  var group = item.dataset.lightboxGroup;
  if(!group) return;
  var allInGroup = document.querySelectorAll('[data-lightbox-group="' + group + '"]');
  var imgs = [];
  var clickedIdx = 0;
  allInGroup.forEach(function(el, i){
    var img = el.querySelector('img');
    if(img) imgs.push({src: img.src});
    if(el === item) clickedIdx = i;
  });
  openLightbox(imgs[clickedIdx].src, imgs, clickedIdx);
});

/* Product page main image click opens lightbox */
var productMainImg = $('#productMainImg');
if(productMainImg){
  productMainImg.addEventListener('click', function(){
    var imgs = [];
    $$('.product-thumb').forEach(function(t){ imgs.push({src: t.dataset.img}); });
    if(imgs.length === 0) imgs.push({src: productMainImg.src});
    var activeIdx = 0;
    $$('.product-thumb').forEach(function(t, i){ if(t.classList.contains('active')) activeIdx = i; });
    openLightbox(productMainImg.src, imgs, activeIdx);
  });
}

/* ── Keyboard Shortcuts ── */
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    if(lightboxOverlay && lightboxOverlay.classList.contains('active')) closeLightbox();
    else if(productModal && productModal.classList.contains('open')) closeProductModal();
    else if(cartSidebar && cartSidebar.classList.contains('open')) closeCart();
    else if(mobileMenu && mobileMenu.classList.contains('open')) closeMobileMenu();
  }
  if(lightboxOverlay && lightboxOverlay.classList.contains('active')){
    if(e.key === 'ArrowLeft' && lightboxPrev) lightboxPrev.click();
    if(e.key === 'ArrowRight' && lightboxNext) lightboxNext.click();
  }
});

/* ── Scroll Reveal (IntersectionObserver) ── */
function observeRevealElements(){
  if(!('IntersectionObserver' in window)){
    $$('.reveal').forEach(function(el){ el.classList.add('visible'); });
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 0.1, rootMargin: '0px 0px -50px 0px'});
  $$('.reveal:not(.visible)').forEach(function(el){ observer.observe(el); });
}
observeRevealElements();

/* ── Hero Parallax ── */
var heroContent = document.querySelector('.hero-content');
var ticking = false;
if(heroContent){
  window.addEventListener('scroll', function(){
    if(!ticking){
      requestAnimationFrame(function(){
        var scrollY = window.scrollY;
        if(scrollY < window.innerHeight){
          heroContent.style.transform = 'translateY(' + (scrollY * 0.2) + 'px)';
          heroContent.style.opacity = 1 - (scrollY / (window.innerHeight * 0.75));
        }
        ticking = false;
      });
      ticking = true;
    }
  }, {passive: true});
}

/* ── Faces Carousel (3D ring, scroll-driven) ── */
var facesSection = $('#facesCarousel');
if(facesSection){
  var facesRing = $('#facesRing');
  var facesCards = facesSection.querySelectorAll('.faces-card');
  var totalCards = facesCards.length;
  var anglePerCard = 360 / totalCards;
  var facesTicking = false;
  var isMobile = window.innerWidth <= 480;
  var isTablet = window.innerWidth <= 768 && !isMobile;
  var radius = isMobile ? 340 : (isTablet ? 400 : 500);
  var prevFront = -1;


  window.addEventListener('scroll', function(){
    if(!facesTicking){
      requestAnimationFrame(function(){
        var rect = facesSection.getBoundingClientRect();
        var sectionH = facesSection.offsetHeight;
        var viewH = window.innerHeight;
        var scrolled = -rect.top;
        var scrollRange = sectionH - viewH;
        if(scrollRange <= 0){ facesTicking = false; return; }
        var progress = Math.max(0, Math.min(1, scrolled / scrollRange));
        /* Rotate through all 7 cards: last card (Costa) is the final stop */
        var targetAngle = -(progress * (totalCards - 1) * anglePerCard);
        if(facesRing) facesRing.style.transform = 'translateZ(-' + radius + 'px) rotateY(' + targetAngle + 'deg)';
        /* Highlight front card */
        var frontIdx = Math.round(progress * (totalCards - 1));
        frontIdx = Math.max(0, Math.min(totalCards - 1, frontIdx));
        if(frontIdx !== prevFront){
          facesCards.forEach(function(c){ c.classList.remove('front'); });
          facesCards[frontIdx].classList.add('front');
          prevFront = frontIdx;
        }
        facesTicking = false;
      });
      facesTicking = true;
    }
  }, {passive: true});
}

/* ── Utility ── */
function getSizedImage(url, size){
  if(!url) return '';
  return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
}

function escapeHtml(str){
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

})();
